import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Input,
  SubmitButton,
  SubTab,
  SubInput,
  RenderInputFields,
} from "../Form/Form";

import { createSlug } from "../../util/fn";
import { requestHandler } from "../../services/requestHandler";

const Edit = (props) => {
  const { id } = props.match.params;
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);

  const { response, request } = useRequest();

  const getSingleCity = async () => {
    const response = await requestHandler("GET", `city/single/${id}`);
    console.log(response)
    if(response && response.status){
      setValue("name", response.city?.name)
      setValue("shippingCost", response.city?.shippingCost)
    }
  };

  useEffect(() => {
    document.title = "Edit City";
    if(id){
      getSingleCity()
    }
  }, [id]);
  useEffect(() => {
    if (response) {
      console.log("response", response);
      toast.success("City updated successfully.");
      history.push("/cities");
    }
  }, [response]);

  const onSubmit = (data) => {
    const { name, shippingCost } = data;

    request("PUT", "city", {
      id,
      name,
      shippingCost,
    });
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "City",
        type: "text",
        name: "name",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Input,
        label: "Shipping Cost",
        type: "text",
        name: "shippingCost",
        registerFields: {
          required: true,
          pattern: /^[0-9]*$/,
        },
        registerFieldsFeedback: {
          pattern: "Shipping Cost must be a number.",
        },
      },
    ],
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit City"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/cities", name: "Back To cities" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Edit City</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <RenderInputFields
                        InputFields={InputFields}
                        errors={errors}
                        register={register}
                      />
                    </div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
